import React from "react";
import Box from "@mui/material/Box";
import { RHFSelectField } from "../RHFSelectField";

export const VariantSelectors = React.memo(function VariantSelectors({
  item,
  fieldPrefix,
  control,
  validationHelper,
  selectedColour,
  selectedSize,
  sizes,
  fits,
  QuantitySlot,
  singleRow = false,
}) {
  const hasColour = !!item?.colours;
  const hasSize = !!item?.sizes;
  const hasFit = !!item?.fits;
  const gridTemplateColumns = singleRow
    ? // Force all selectors + quantity onto one responsive row
      `repeat(${
        [hasColour, hasSize, hasFit].filter(Boolean).length + 1
      }, minmax(110px,1fr))`
    : hasColour && hasSize
      ? "repeat(2, minmax(130px,1fr))"
      : "repeat(1, minmax(130px,1fr))";
  return (
    <Box sx={{ display: "grid", gap: 1, width: "100%", gridTemplateColumns }}>
      {hasColour && (
        <RHFSelectField
          name={`${fieldPrefix}.colour`}
          label="Colour"
          options={item?.colours}
          optionIdentifiers={{ id: "code", label: "description" }}
          control={control}
          validationHelper={validationHelper}
          rules={{ required: false }}
          viewMode={false}
          size="small"
        />
      )}
      {hasSize && (
        <RHFSelectField
          name={`${fieldPrefix}.size`}
          label="Size"
          options={sizes}
          optionIdentifiers={{ id: "code", label: "description" }}
          control={control}
          validationHelper={validationHelper}
          rules={{ required: false }}
          viewMode={selectedColour ? false : true}
          size="small"
        />
      )}
      {hasFit && (
        <RHFSelectField
          name={`${fieldPrefix}.fit`}
          label="Fit"
          options={fits}
          optionIdentifiers={{ id: "code", label: "description" }}
          control={control}
          validationHelper={validationHelper}
          rules={{ required: false }}
          viewMode={selectedSize ? false : true}
          size="small"
          sx={{ gridColumn: hasColour && hasSize ? "1 / span 1" : "1 / -1" }}
        />
      )}
      <Box
        sx={{
          gridColumn: singleRow
            ? "auto"
            : !hasFit && hasColour && hasSize
              ? "1 / -1"
              : hasFit && hasColour && hasSize
                ? "1 / span 2"
                : "1 / -1",
        }}
      >
        {QuantitySlot}
      </Box>
    </Box>
  );
});

export default VariantSelectors;
